import { createDynamicContext } from 'js/store/helpers';

const UPDATE_LAST_WINNERS = 'UPDATE_LAST_WINNERS';
const UPDATE_PRIZES = 'UPDATE_PRIZES';
const UPDATE_PRIZES_WON = 'UPDATE_PRIZES_WON';
const UPDATE_JOIN_STATE = 'UPDATE_JOIN_STATE';
const UPDATE_PARTICIPATING_GAMES = 'UPDATE_PARTICIPATING_GAMES';
const UPDATE_STATUS = 'UPDATE_STATUS';
const UPDATE_RULES = 'UPDATE_RULES';
const UPDATE_END_TIME = 'UPDATE_END_TIME';
const UPDATE_START_TIME = 'UPDATE_START_TIME';
const UPDATE_ELIGIBLE = 'UPDATE_ELIGIBLE';
const UPDATE_MYSTERY_PARCEL_ID = 'UPDATE_MYSTERY_PARCEL_ID';
const UPDATE_DISPLAY_NAME = 'UPDATE_DISPLAY_NAME';
const UPDATE_REGISTRATION_STATUS = 'UPDATE_REGISTRATION_STATUS';
const UPDATE_STATUS_DELAY = 'UPDATE_STATUS_DELAY';
const UPDATE_TERMS_AND_CONDITIONS_URL = 'UPDATE_TERMS_AND_CONDITIONS_URL';
const UPDATE_BANNER_URL = 'UPDATE_BANNER_URL';
const UPDATE_CUSTOM_ATTRIBUTES = 'UPDATE_CUSTOM_ATTRIBUTES';

const defaultState = {
    bannerUrl: '',
    lastWinners: [],
    prizes: [],
    prizesWon: [],
    join: {
        joinError: false,
        joined: false,
        joining: false,
        hasNickname: false,
        nicknameNeeded: true,
        displaySetNickname: false
    },
    participatingGames: [],
    mysteryParcelId: undefined,
    status: '',
    rules: '',
    eventStartTime: 0,
    eventEndTime: 0,
    eligible: false,
    displayName:'',
    registrationStatus: '',
    statusDelay: false,
    termsAndConditionsUrl: '',
    customAttributes: []
};

const reducer = (reducerSuffix) => (state = defaultState, { type, payload } = {}) => {
    switch (type) {
        case UPDATE_LAST_WINNERS:
        case UPDATE_LAST_WINNERS + reducerSuffix:
            return { ...state, lastWinners: payload };
        case UPDATE_PRIZES:
        case UPDATE_PRIZES + reducerSuffix:
            return { ...state, prizes: payload };
        case UPDATE_PRIZES_WON:
        case UPDATE_PRIZES_WON + reducerSuffix:
            return { ...state, prizesWon: payload };
        case UPDATE_JOIN_STATE:
        case UPDATE_JOIN_STATE + reducerSuffix:
            return { ...state, join: { ...state.join, ...payload } };
        case UPDATE_PARTICIPATING_GAMES:
        case UPDATE_PARTICIPATING_GAMES + reducerSuffix:
            return { ...state, participatingGames: payload };
        case UPDATE_STATUS:
        case UPDATE_STATUS + reducerSuffix:
            return { ...state, status: payload };
        case UPDATE_RULES:
        case UPDATE_RULES + reducerSuffix:
            return { ...state, rules: payload };
        case UPDATE_END_TIME:
        case UPDATE_END_TIME + reducerSuffix:
            return { ...state, eventEndTime: payload };
        case UPDATE_START_TIME:
        case UPDATE_START_TIME + reducerSuffix:
            return { ...state, eventStartTime: payload };
        case UPDATE_ELIGIBLE:
        case UPDATE_ELIGIBLE + reducerSuffix:
            return { ...state, eligible: payload };
        case UPDATE_MYSTERY_PARCEL_ID:
        case UPDATE_MYSTERY_PARCEL_ID + reducerSuffix:
            return { ...state, mysteryParcelId: payload };
        case UPDATE_DISPLAY_NAME:
        case UPDATE_DISPLAY_NAME + reducerSuffix:
            return { ...state, displayName: payload };
        case UPDATE_REGISTRATION_STATUS:
        case UPDATE_REGISTRATION_STATUS + reducerSuffix:
            return { ...state, registrationStatus: payload };
        case UPDATE_STATUS_DELAY:
        case UPDATE_STATUS_DELAY + reducerSuffix:
            return { ...state, statusDelay: payload };
        case UPDATE_TERMS_AND_CONDITIONS_URL:
        case UPDATE_TERMS_AND_CONDITIONS_URL + reducerSuffix:
            return { ...state, termsAndConditionsUrl: payload };
        case UPDATE_BANNER_URL:
        case UPDATE_BANNER_URL + reducerSuffix:
            return { ...state, bannerUrl: payload };
        case UPDATE_CUSTOM_ATTRIBUTES:
        case UPDATE_CUSTOM_ATTRIBUTES + reducerSuffix:
            return { ...state, customAttributes: payload };
        default:
            return state;
    }
};

export const {
    withDynamicReducer,
    useDynamicReducerSelector,
    useDynamicReducerDispatch
} = createDynamicContext('MysteryParcel', { reducer, defaultState });

export const updateLastWinners = lastWinners => ({
    type: UPDATE_LAST_WINNERS,
    payload: lastWinners
});

export const updatePrizes = prizes => ({
    type: UPDATE_PRIZES,
    payload: prizes
});

export const updatePrizesWon = prizes => ({
    type: UPDATE_PRIZES_WON,
    payload: prizes
});

export const updateJoinState = join => ({
    type: UPDATE_JOIN_STATE,
    payload: join
});

export const updateParticipatingGamesState = participatingGames => ({
    type: UPDATE_PARTICIPATING_GAMES,
    payload: participatingGames
});

export const updateStatus = status => ({
    type: UPDATE_STATUS,
    payload: status
});

export const updateRules = rules => ({
    type: UPDATE_RULES,
    payload: rules
});

export const updateEndTime = eventEndTime => ({
    type: UPDATE_END_TIME,
    payload: eventEndTime
});

export const updateStartTime = startTime => ({
    type: UPDATE_START_TIME,
    payload: startTime
});

export const updateEligible = eligible => ({
    type: UPDATE_ELIGIBLE,
    payload: eligible
});

export const updateMysteryParcelId = mysteryParcelId => ({
    type: UPDATE_MYSTERY_PARCEL_ID,
    payload: mysteryParcelId
});

export const updateDisplayName = displayName => ({
    type: UPDATE_DISPLAY_NAME,
    payload: displayName
});

export const updateRegistrationStatus = registrationStatus => ({
    type: UPDATE_REGISTRATION_STATUS,
    payload: registrationStatus
});

export const updateStatusDelay = statusDelay => ({
    type: UPDATE_STATUS_DELAY,
    payload: statusDelay
});

export const updateTermsAndConditionsUrl = url => ({
    type: UPDATE_TERMS_AND_CONDITIONS_URL,
    payload: url
});

export const updateBannerUrl = bannerUrl => ({
    type: UPDATE_BANNER_URL,
    payload: bannerUrl
});

export const updateCustomAttributes = customAttributes => ({
    type: UPDATE_CUSTOM_ATTRIBUTES,
    payload: customAttributes
});

